const CHAVES_QUANTIDADE = ["quantidade", "saldo", "estoque"];
const CHAVES_TECNICAS_VARIACAO = [
  "id",
  "id_produto",
  "id_produto_combinacao",
  "combinacao_json",
  "descricao_combinacao",
];

function parseJson(valor) {
  if (typeof valor !== "string") return valor;

  try {
    return JSON.parse(valor);
  } catch (error) {
    return valor;
  }
}

function getValorQuantidade(item) {
  const chave = CHAVES_QUANTIDADE.find((nome) => item[nome] !== undefined);
  const valor = chave ? Number(item[chave]) : 0;

  return Number.isFinite(valor) ? valor : 0;
}

function getValorAtributo(valor) {
  if (valor === null || valor === undefined || valor === "") return "—";

  if (Array.isArray(valor)) {
    return valor.map(getValorAtributo).join(", ");
  }

  if (typeof valor === "object") {
    return (
      valor.nome ||
      valor.name ||
      valor.descricao ||
      valor.valor ||
      valor.label ||
      valor.codigo ||
      "—"
    );
  }

  return String(valor);
}

function expandirCombinacao(combinacao) {
  if (!combinacao || typeof combinacao !== "object") return [];

  const json = parseJson(combinacao.combinacao_json);
  if (Array.isArray(json)) return json;
  if (json && typeof json === "object") return [json];

  const interna = parseJson(combinacao.combinacao);
  if (Array.isArray(interna)) return interna;
  if (interna && typeof interna === "object") return [interna];

  return [combinacao];
}

export function normalizarVariacoes(produto = {}) {
  const origem =
    produto.combinacao ||
    produto.combinacoes ||
    produto.produto_combinacoes ||
    [];
  const origemNormalizada = parseJson(origem);
  const combinacoes = Array.isArray(origemNormalizada) ? origemNormalizada : [];

  return combinacoes.flatMap(expandirCombinacao).map((item, index) => {
    const atributos = Object.keys(item)
      .filter(
        (chave) =>
          !CHAVES_QUANTIDADE.includes(chave) &&
          !CHAVES_TECNICAS_VARIACAO.includes(chave)
      )
      .map((chave) => ({
        nome: chave,
        valor: getValorAtributo(item[chave]),
      }));

    if (!atributos.length) {
      atributos.push({
        nome: "Variação",
        valor: item.descricao_combinacao || `Combinação ${index + 1}`,
      });
    }

    return {
      id: item.id_produto_combinacao || item.id || index,
      atributos,
      quantidade: getValorQuantidade(item),
    };
  });
}

export function normalizarLotes(produto = {}) {
  const origem =
    produto.lotes || produto.produto_lotes || produto.produtoLotes || [];
  const lotes = parseJson(origem);

  if (!Array.isArray(lotes)) return [];

  return lotes.map((lote, index) => ({
    id: lote.id_produto_lote || lote.id || index,
    numero: lote.numero_lote || lote.numero || lote.lote || "Não informado",
    dataFabricacao: lote.data_fabricacao || lote.fabricacao || null,
    dataValidade: lote.data_validade || lote.validade || null,
    quantidade: getValorQuantidade(lote),
  }));
}

export function formatarUnidadeMedida(unidadeMedida) {
  if (!unidadeMedida) return "unidades";

  if (typeof unidadeMedida === "object") {
    return (
      unidadeMedida.sigla ||
      unidadeMedida.nome ||
      unidadeMedida.descricao ||
      "unidades"
    );
  }

  return String(unidadeMedida);
}

export function filtrarPorTexto(itens, busca, campos) {
  const normalizarTexto = (valor) =>
    String(valor || "")
      .trim()
      .toLocaleLowerCase("pt-BR")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  const termo = normalizarTexto(busca);

  if (!termo) return itens;

  return itens.filter((item) =>
    normalizarTexto(campos(item).join(" ")).includes(termo)
  );
}
